import { render, staticRenderFns } from "./PayerOverpayments.vue?vue&type=template&id=a389f9f6&scoped=true"
import script from "./PayerOverpayments.vue?vue&type=script&lang=js"
export * from "./PayerOverpayments.vue?vue&type=script&lang=js"
import style0 from "./PayerOverpayments.vue?vue&type=style&index=0&id=a389f9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a389f9f6",
  null
  
)

export default component.exports